import { ImportSpecType as ApiImportSpecType } from "src/graphql/import-export/__generated__/graphql";
import { ImportSpecificationType } from "src/types/importSpecification";

const IMPORT_SPECIFICATION_TYPE_MAP: { [key in ApiImportSpecType]: ImportSpecificationType } = {
  CASE: "case",
  BLACKLIST: "blacklist",
};

const IMPORT_SPECIFICATION_TYPE_MAP_REVERSE = Object.entries(IMPORT_SPECIFICATION_TYPE_MAP).reduce(
  (reverseMap, [apiType, type]) => {
    reverseMap[type] = apiType as ApiImportSpecType;
    return reverseMap;
  },
  {} as { [key in ImportSpecificationType]: ApiImportSpecType }
);

export const mapToImportSpecificationType = (
  importSpecType: ApiImportSpecType
): ImportSpecificationType => {
  return IMPORT_SPECIFICATION_TYPE_MAP[importSpecType];
};

export const mapToApiImportSpecificationType = (
  importSpecification: ImportSpecificationType
): ApiImportSpecType => {
  return IMPORT_SPECIFICATION_TYPE_MAP_REVERSE[importSpecification];
};
